module.exports = __webpack_public_path__ + "img/3.3301386f.png";